/**
 * RailListContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

/**
 * Props for RailListContainer component.
 */
interface Props {
  focused: boolean;
}

const RailListContainer = styled.div<Props>`
  pointer-events: none;
  top: ${513 * Screen.widthRatio}px;
  position: absolute;
  width: max-content;
  z-index: 1;
`;

export default withAnimation(RailListContainer);
